import axios from 'axios';

const BASE_URL = 'https://casacru.somee.com/api/v1';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // puedes agregar más configuraciones aquí si lo necesitas
});

export default {
  // Método para obtener todos los registros
  getAll(pagina) {
    return apiClient.get('/Productos/GetAllProductos/' + pagina);
  },
  getByClasificaciones(clasificacion, pageNumber) {
    return apiClient.get(
      '/Productos/GetAllProductosByClasificacion/' +
        clasificacion +
        '/' +
        pageNumber
    );
  },
  getByCodigo(codigo) {
    return apiClient.get('/Productos/GetProductosByCodigo/' + codigo);
  },
  getAllClasificaciones() {
    return apiClient.get('/Productos/GetAllClasificaciones');
  },

  GetByDescription(descripcion) {
    return apiClient.get('/Productos/GetProductsByDescription/'+descripcion);
  },
};
